export default __webpack_public_path__ + "static/media/genric-error.e71d9a64.png";